export default [
  'Program',
  'Project',
  'dbGaP Study ID',
  'Disease Type',
  'Release State',
  'Submission State',
  'Cases Expected',
  'Cases registered in dbGaP',
  'Cases in GDC',
  'Date Expected for Release',
  'Initial Upload Date',
  'Project Last Update Date',
  'Cases with Harmonized Data',
  'Cases with Read Group',
  'Cases with Aliquot',
  'Cases with Slide',
  'Cases with Sample',
  'Cases with Analyte',
  'Cases with Portion',
  'Cases with Family History',
  'Cases with Demographic',
  'Cases with Treatment',
  'Cases with Exposure',
  'Cases with Diagnosis',
  'Cases with Submitted Unaligned Reads',
  'Cases with Aligned Reads Metric',
  'Cases with Pathology Report',
  'Cases with Biospecimen Supplement',
  'Cases with Submitted Tangent Copy Number',
  'Cases with Methylation Beta Value',
  'Cases with Masked Somatic Mutation',
  'Cases with Annotated Somatic Mutation',
  'Cases with Submitted Aligned Reads',
  'Cases with Simple Somatic Mutation',
  'Cases with Filtered Copy Number Segment',
  'Cases with Aggregated Somatic Mutation',
  'Cases with Sample Level MAF',
  'Cases with Simple Germline Variation',
  'Cases with Slide Image',
  'Cases with Archive',
  'Cases with miRNA Expression',
  'Cases with Submitted Methylation Beta Value',
  'Cases with Copy Number Segment',
  'Cases with Aligned Reads',
  'Cases with Exon Expression',
  'Cases with Gene Expression',
  'Cases with Clinical Supplement',
  'Cases with Run Metadata',
  'Cases with Analysis Metadata',
  'Cases with Experiment Metadata',
  'Cases with Tumor',
  'Cases with Normal',
  'Cases with Abnormal',
  'Cases with Peritumoral',
  'Cases with WGS',
  'Cases with WXS',
  'Cases with Low Pass WGS',
  'Cases with Validation',
  'Cases with RNA-Seq',
  'Cases with miRNA-Seq',
  'Cases with Total RNA-Seq'
];
